module.exports = __webpack_public_path__ + "assets/projectInfo.25b1ba55.svg";